import { jsxs as n, jsx as o } from "react/jsx-runtime";
const i = ({
  width: r,
  height: t,
  className: e
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 20 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M7.41797 6.29922C7.6763 3.29922 9.21797 2.07422 12.593 2.07422H12.7013C16.4263 2.07422 17.918 3.56589 17.918 7.29089V12.7242C17.918 16.4492 16.4263 17.9409 12.7013 17.9409H12.593C9.24297 17.9409 7.7013 16.7326 7.4263 13.7826",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.499 10H3.01562",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M4.87565 7.20898L2.08398 10.0007L4.87565 12.7923",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      )
    ]
  }
);
export {
  i as Content
};
